module.exports = __webpack_public_path__ + "img/img1.ee7716f3.jpg";